import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60279d6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-plus fas" }, null, -1))
const _hoisted_3 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_aemet_list_component = _resolveComponent("aemet-list-component")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_page_buttons_component = _resolveComponent("page-buttons-component")!
  const _component_aemet_form_component = _resolveComponent("aemet-form-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_aemet_list_component, { ref: "aemetList" }, null, 512)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_page_buttons_component, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: _ctx.$t('btn.create'),
            placement: "left"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "btn",
                type: "primary",
                size: "large",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAemetFormDialog())),
                circle: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showAemetForm,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showAemetForm) = $event)),
        title: _ctx.$t(_ctx.aemetForm?.id ? 'label.aemetEdit' : 'label.aemetCreate'),
        width: "50%",
        "destroy-on-close": "",
        "custom-class": "app-form"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeAemetFormDialog()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveAemetForm()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_aemet_form_component, {
            ref: "aemetForm",
            id: _ctx.aemetForm?.id
          }, null, 8, ["id"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ]))
}